import { render, staticRenderFns } from "./CreateParameterFromTemplateSheet.vue?vue&type=template&id=2bb84b14"
import script from "./CreateParameterFromTemplateSheet.vue?vue&type=script&lang=js"
export * from "./CreateParameterFromTemplateSheet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports